import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import ModalContainer from 'app/components/ModalContainer';
import useWindowSize, { TABLET_WIDTH } from 'app/hooks/useWindowSize';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';
import moment from 'moment';
import { getDetailOrderApi } from 'app/services/checkoutApi';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { windowOpenLink } from 'utils/helper';
const TicketExpiredModal = ({ isShow, onCloseDialog, ticketInfo }: any) => {
  const translations = useSelector(selectTranslations);
  const [newTicket, setNewTicket] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  let dataItem: any = null;
  const { device } = useWindowSize();
  const getDetailOrder = async () => {
    try {
      const { data: getDetail } = await getDetailOrderApi(
        ticketInfo.upgradeOrderId,
      );
      setNewTicket(getDetail);
      return getDetail;
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useMemo(() => {
    if (isShow && !_.isEmpty(ticketInfo?.upgradeOrderId)) {
      setIsLoading(true);
      getDetailOrder();
    } else {
      setNewTicket(null);
    }
  }, [isShow, ticketInfo?.upgradeOrderId]);

  return (
    <ModalContainer
      maskClosable={false}
      CloseIcon={
        device === 'mobile' || device === 'tablet' ? (
          <CloseIcon width={11} height={11} />
        ) : undefined
      }
      styleSlots={{
        modalContentStyle:
          device === 'mobile' || device === 'tablet'
            ? {
                maxWidth: '95%',
                minWidth: undefined,
                minHeight: undefined,
                height: 'auto !important',
                maxHeight: 'auto !important',
              }
            : {
                minWidth: 415,
                minHeight: 220,
                height: 'auto !important',
              },
        modalStyle: {
          height: 'auto',
        },
      }}
      modalProps={{
        width: 'auto',
        style: {
          overscrollBehavior: 'none',
          height: 'auto',
        },
      }}
      closable
      isShow={isShow}
      onCloseDialog={onCloseDialog}
    >
      <LoadingContainer minHeight={'150px'} loading={isLoading}>
        <div className="flex">
          <div className="w-100 mb-2">
            <p
              className="txt-text"
              style={{
                fontSize: 16,
                fontWeight: 600,
                margin: 0,
              }}
            >
              {' '}
              {translations ? translations['b2b.txt.Ticket-exchange-info'] : ''}
            </p>
            <p
              className="txt-text"
              style={{
                color: '#808080',
              }}
            >
              {translations
                ? translations['b2b.txt.ticket-exchanged-notice']
                : ''}
            </p>
          </div>
          <div className="w-100 d-flex mb-2">
            <div
              className="w-40"
              style={{
                width: 125,
              }}
            >
              <p
                className="txt-text m-0"
                style={{
                  fontWeight: 600,
                }}
              >
                {translations ? translations['b2b.txt.implement-date'] : ''}
              </p>
            </div>
            <div className="">
              <p
                className="txt-text m-0"
                style={{
                  fontWeight: 500,
                }}
              >
                {newTicket?.orderdate?.datetimeDMYHIS
                  ? moment(
                      newTicket?.orderdate?.datetimeDMYHIS,
                      'HH:mm:ss DD/MM/YYYY',
                    ).format('DD/MM/YYYY HH:mm:ss')
                  : ''}
              </p>
            </div>
          </div>
          <div className="w-100 d-flex mb-2">
            <div
              className="w-40"
              style={{
                width: 125,
              }}
            >
              <p
                className="txt-text m-0"
                style={{
                  fontWeight: 600,
                }}
              >
                {translations ? translations['b2b.table.PNR'] : ''}
              </p>
            </div>
            <div
              className=""
              onClick={() => {
                windowOpenLink({
                  url:
                    '/check-tickets/exchange-detail/' +
                    newTicket?.idHash +
                    `?parentId=${ticketInfo?.idHash}`,
                });
              }}
            >
              <p
                className="txt-text m-0"
                style={{
                  color: '#FAB317',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                {newTicket?.id}
              </p>
            </div>
          </div>
          <div className="w-100 d-flex">
            <div
              className="w-40 d-flex"
              style={{
                width: 125,
                minWidth: 125,
              }}
            >
              <p
                className="txt-text m-0"
                style={{
                  fontWeight: 600,
                }}
              >
                {translations ? translations['b2b.txt.create-user'] : ''}
              </p>
            </div>
            <div
              className="break-all text-wrap"
              style={{
                wordBreak: 'break-all',
              }}
            >
              <p
                className="txt-text m-0"
                style={{
                  fontWeight: 500,
                }}
              >
                {newTicket?.agent?.name}
              </p>
            </div>
          </div>
        </div>
      </LoadingContainer>
    </ModalContainer>
  );
};

export default TicketExpiredModal;
